<template>
  <div class="big">
    <el-dialog :title="`${!isAdd ? '添加' : '编辑'}填空题`"
               :visible.sync="dialog"
               width="500px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div class="add-fill-dia">
        <el-form :model="fillForm"
                 :rules="radioRules"
                 ref="fillFormRef"
                 label-width="60px">
          <div class="way">
            <el-form-item label="方式"
                          prop="answer_obj">
              <el-select v-model="fillForm.answer_obj"
                         placeholder="请选择方式">
                <el-option label="患者回答"
                           :value="1"></el-option>
                <el-option label="医生回答"
                           :value="2"></el-option>
                <el-option label="医生患者都可回答"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否必填"
                          prop="is_write"
                          label-width="80px"
                          class="fill-box">
              <el-radio-group v-model="fillForm.is_write">
                <el-radio :label="1">必填</el-radio>
                <el-radio :label="0">非必填</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item label=""
                        class="cus-textarea"
                        prop="title">
            <p class="prompt">
              示例：在编辑文本时插入{$暗提示文字} 暗提示文字30字以内
            </p>
            <el-input type="textarea"
                      rows="3"
                      v-model="fillForm.title"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center; padding: 10px 0">
        <el-button @click="closeShow(false)">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('fillFormRef')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: {
    isAdd: {
      type: Number,
      require: true
    },
    content: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: true,
      fillForm: {
        title: '',
        answer_obj: '',
        is_write: 1
      },
      radioRules: {
        title: [
          { required: true, message: '请输入题目', trigger: 'blur' },
          { max: 300, message: '题目长度100字以内', trigger: 'blur' }
        ],
        answer_obj: [
          { required: true, message: '请选择方式', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    if (this.isAdd) {
      this.fillForm = _.pick(this.content, [
        'title',
        'answer_obj',
        'is_write',
        '$index',
        'desc'
      ]);
    }
  },
  methods: {
    closeShow(data) {
      this.$emit('closeShow', data);
    },
    //提交
    submitForm(formName) {
      let fillArr = this.getExecStrs(this.fillForm.title);
      let num = this.getCharCount(this.fillForm.title, '{');
      let isLength = fillArr.some((item) => {
        return item.length > 30;
      });
      if (isLength) {
        this.$message.error('暗提示文字，30字以内');
        return;
      }
      if (num !== fillArr.length) {
        this.$message.error('如果没有暗提示文字,请加一个空格');
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = Object.assign(this.fillForm, {
            item_type: 4
          });
          this.closeShow(data);
        } else {
          return false;
        }
      });
    },
    getCharCount(str, char) {
      let regex = new RegExp(char, 'g');
      let result = str.match(regex);
      let count = !result ? 0 : result.length;
      return count;
    },
    getExecStrs(str) {
      let reg = /\{\$(.+?)\}/g;
      let list = [];
      let result = null;
      do {
        result = reg.exec(str);
        result && list.push(result[1]);
      } while (result);
      return list;
    },
    resetForm() {}
  }
};
</script>
<style lang="scss" scoped>
.add-fill-dia {
  padding: 20px 20px 0 20px;
  box-sizing: border-box;

  .way {
    display: flex;
    height: 50px;
    .fill-box {
      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        .el-radio-group {
          display: flex;
        }
      }
    }
  }
  .cus-textarea {
    margin-top: 10px;
    margin-bottom: 40px;
    .prompt {
      height: 20px;
      line-height: 20px;
      margin: 0;
      color: #cac7c7;
    }
  }
}
</style>
